import createHostComponent from '../../createHostComponent';
import alias from './props/alias';
import defaults from './props/default';
var Button = createHostComponent('button', alias, defaults);
export default Button;
